import React, { Component } from "react";
import { ModuleAccordionGroup } from '@loanbossinc/component-library';
import ordinal from 'ordinal';
import moment from "moment";
import { AccordionSection } from "component-lib/AccordionSection";
import { rows } from './section-loan-extension-rows';
import { LOAN_SECTION_KEYS } from '../loan.constants';
import { findSummaryText } from '../loanDetailEditUtil';
const SHORTHAND_FIELD = "LoanExtensions";
// EXTENSIONS WILL HAVE TO GET AN OPTIONAL PARAM!!!!! because the section key is built
// partially by the index value for each extension. the form builder will have to premap the values
// so that it only grabs the one extension

export class LoanExtensions extends Component {
  mapExtensionGroups = () => {
    const { data, history, loanId, enableEditButton, modifySummaryText, eventHandlers } = this.props;
    const summaryText = findSummaryText(data,SHORTHAND_FIELD);
    
    if (!data || !data.extensions) return null;

    const groupsArray = [
      {
        title: 'Extensions'
        , key: LOAN_SECTION_KEYS.EXTENSIONS
        , isTitleGroup: true
        , isExpandable: false
        , hasSummaryText: true
        , summaryText: summaryText
        , modifySummaryText: () => modifySummaryText(SHORTHAND_FIELD, summaryText)
        , references: data.references
        , referencedFieldPath: "loans.extensions"
        , isReferenceOptions: true
        , eventHandlers
      }
    ]
    let groups = groupsArray;
    if (data.extensions.length > 0) {
      groups = data.extensions.reduce((accum, extension) => {
        if(data && data.details)
          extension.rateTypeId = data.details.rateTypeId;
        if (!extension) return accum;

        accum.push({
          title: `${ordinal(extension.sortOrder + 1)} Extension`
          , subTitle: this.getSubTitle(extension)
          , sortOrder: extension.sortOrder
          , key: `${LOAN_SECTION_KEYS.EXTENSIONS}-${extension.sortOrder}`
          , isTitleGroup: false
          , isExpandable: true
          , buttonLabel: 'Edit Details'
          , showEditButton: enableEditButton
          , onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.EXTENSIONS}/${extension.id}`)
          , sections: [<AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={extension} />]
        });
        return accum;

      }, groupsArray);

      groups = groups.sort((a, b) => a.sortOrder - b.sortOrder);
    }

    // add new row button
    groups.push({
      isButton: true
      , key: `extensions-add-button`
      , buttonLabel: 'Add new extension'
      , showEditButton: enableEditButton
      , onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.EXTENSIONS}/new/${data.extensions ? data.extensions.length : 0}`)
    });

    return groups;
  }

  getSubTitle = (extension) => {
    const extensionStart = moment.utc(extension.extensionStart).format('MMM D, YYYY');
    const extensionEnd = moment.utc(extension.extensionEnd).format('MMM D, YYYY');

    return `${extensionStart} - ${extensionEnd}`;
  }

  render() {
    const groups = this.mapExtensionGroups();
    const { data, ...other } = this.props;

    return <ModuleAccordionGroup {...other} groups={groups} />;
  }
}
